import React, { useEffect } from 'react';
import { APP_CRASH_FALLBACK, HEADER_TITLE } from '../../../common/constants/data-hooks';
import { TextExtendedNoUseApi } from '../text-extended/text-extended';
import identity from 'lodash/identity';
import noop from 'lodash/noop';
import { ApiContext } from '../../context/api-context/api-context';
import { ExternalTranslationsContext } from '../../context/api-context/translations/external-translations-context';
import { ConfigurationContext } from '../../context/configuration-context/configuration-context';
import { TPAComponentsProvider, Button, HoverStyles } from '../../../ui';
import { AppWrapper } from '../app-wrapper/app-wrapper';
import { HorizontalDivider } from '../dividers';
import { getIsRtl, getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import styles from './fallback-state.module.scss';
import { useContext } from '../../use-context-selector';
const TRASLATION_FALLBACKS = {
    'error-boundary-fallback.message': 'Hmm, that didn’t work. Refresh the page and try again.',
    'error-boundary-fallback.button-label': 'Refresh',
    'header.all-comments': 'Comments',
};
const translationFn = (isTranslateDebug, propsT, ctxT) => (key, params) => {
    if (isTranslateDebug) {
        return key;
    }
    const t = propsT || ctxT || identity;
    const result = t(key, params);
    if (!result || result === key) {
        return TRASLATION_FALLBACKS[key];
    }
    return result;
};
const ErrorBoundaryFallback = (props) => {
    let headerText = TRASLATION_FALLBACKS['header.all-comments'];
    let message = TRASLATION_FALLBACKS['error-boundary-fallback.message'];
    let buttonLabel = TRASLATION_FALLBACKS['error-boundary-fallback.button-label'];
    let biShowFallbackState = noop;
    let isMobile = false;
    let isRtl = false;
    let resourceId = '';
    const error = props?.workerError?.error;
    const errorCode = props?.workerError?.errorId;
    if (error) {
        console.info(error);
    }
    try {
        const ctx = React.useContext(ExternalTranslationsContext);
        const isTranslateDebug = typeof window !== 'undefined' && window.location.search.includes('debug-translate');
        const t = translationFn(isTranslateDebug, props.t, ctx.t);
        message = t('error-boundary-fallback.message');
        buttonLabel = t('error-boundary-fallback.button-label');
        headerText = t('header.all-comments', { count: props.commentCount ?? 0 });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const apiCtx = useContext(ApiContext);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const configContext = React.useContext(ConfigurationContext);
        resourceId = configContext.resourceId ?? resourceId;
        biShowFallbackState = apiCtx?.actions.biShowFallbackState ?? biShowFallbackState;
        isMobile = getIsMobile(apiCtx) ?? isMobile;
        isRtl = getIsRtl(apiCtx) ?? isRtl;
    }
    catch { }
    useEffect(() => {
        biShowFallbackState({ resourceId });
    }, []);
    return (React.createElement(TPAComponentsProvider, { value: { mobile: isMobile, rtl: isRtl } },
        React.createElement(AppWrapper, null,
            isMobile && React.createElement(HorizontalDivider, { type: "header" }),
            React.createElement("div", { className: styles.headerContainer },
                React.createElement("div", { "data-hook": HEADER_TITLE, className: styles.left },
                    React.createElement(TextExtendedNoUseApi, { className: styles.commentCount, typography: "titleSmall", mobile: isMobile }, headerText))),
            React.createElement("div", { className: styles.container, "data-hook": APP_CRASH_FALLBACK },
                React.createElement("div", { className: styles.text },
                    React.createElement(TextExtendedNoUseApi, { priority: "primary", mobile: isMobile }, message)),
                React.createElement("div", { className: styles.buttonContainer },
                    React.createElement(Button, { onClick: () => window.location.reload(), hoverStyle: HoverStyles.underline }, buttonLabel)),
                errorCode && (React.createElement("div", { className: styles.text },
                    React.createElement(TextExtendedNoUseApi, { priority: "secondary", typography: "contentXSmall", mobile: isMobile },
                        "ErrorId: ",
                        errorCode)))))));
};
export default (props) => {
    try {
        return React.createElement(ErrorBoundaryFallback, { ...props });
    }
    catch {
        return React.createElement("div", null, "Unexpected error");
    }
};
//# sourceMappingURL=fallback-state.js.map